var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.environment !== "production"
    ? _c(
        "div",
        {
          staticClass: "environment-badge",
          class: _vm.badgeClass,
          attrs: { title: "Ambiente: " + _vm.environmentLabel }
        },
        [
          _c("span", { staticClass: "badge-text" }, [
            _vm._v(_vm._s(_vm.environmentLabel))
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }